module.exports = __webpack_public_path__ + "ins05.png?057e08fcc323b1932b5363d758dfe9a7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ins05.png
// module id = 156
// module chunks = 0